const { JOURNEY_TYPE } = require("../../constants");

const getIsSCFJourneySelected = journey => journey === JOURNEY_TYPE.SCF;

module.exports = { getIsSCFJourneySelected };
